import { BrowserRouter as Router, Link } from "react-router-dom";
import { useState } from "react";
import React from 'react'

function Footer() {
  let time = new Date().toLocaleTimeString()
  const [ctime, setCtime] = useState(time)
  const UpdateTime = () => {
    time = new Date().toLocaleTimeString()
    setCtime(time)
  }
  setInterval(UpdateTime, 1000)
  return (
    <>
      <Router></Router>
      <footer
        className="page-footer font-small stylish-color-dark pt-4 bg-dark text-light"
        style={{ zIndex: "10" }}
      >
        <div className="container text-center text-md-left" style={{ paddingBottom: '20px' }}>
          <div className="row">
            <div className="col-md-4 mx-auto">
              <h5 className="font-weight-bold text-uppercase mt-3 mb-4">
                Deeptam Research Foundation
              </h5>
              <p>
                Learn Programming Concepts in Deeptam Research Foundation
              </p>
              <p><b>{ctime}</b></p>
            </div>
            <hr className="clearfix w-100 d-md-none" />
            <div className="col-md-3 mx-auto">
              <h5 className="font-weight-bold text-uppercase mt-3 mb-4">
                Useful Links
              </h5>
              <ul className="list-unstyled">
                <li>
                  <Link style={{ transition: '0s' }} to="/">Home</Link>
                </li>
                <li>
                  <Link style={{ transition: '0s' }} to="/videos">Tutorials</Link>
                </li>
                <li>
                  <a style={{ transition: '0s' }} target="_blank" rel="noreferrer" href="https://www.youtube.com/channel/UCxNpmV2gyok9bdtpMfQZj1A">YouTube</a>
                </li>
                <li>
                  <Link style={{ transition: '0s' }} to="/contact">Contact Us</Link>
                </li>
              </ul>
            </div>
            <hr className="clearfix w-100 d-md-none" />
            <div className="col-md-2 mx-auto">
              <h5 className="font-weight-bold text-uppercase mt-3 mb-4">
                Tutorials
              </h5>
              <ul className="list-unstyled">
                <li>
                  <Link style={{ transition: '0s' }} to="/videos/python-course/python-1">Python</Link>
                </li>
                <li>
                  <Link style={{ transition: '0s' }} to="/videos/html-projects/how-to-send-form-to-gmail">Send Form to Gmail</Link>
                </li>
                {/* <li>
                  <Link style={{ transition: '0s' }} to="/categories/emulators">Emulators</Link>
                </li> */}
                <li>
                  <Link style={{ transition: '0s' }} to="/videos">And More..</Link>
                </li>
              </ul>
            </div>
            <hr className="clearfix w-100 d-md-none" />
          </div>
        </div>
        {/* <hr /> */}
        {/* <div className="footer-copyright text-center pb-3">
          &copy; 2021 Copyright:
          <a href="https://mdbootstrap.com/"> MDBootstrap.com</a>
        </div> */}
      </footer>
    </>
  );
}

export default Footer;
